import React from "react";
import { T } from "../../constants/theme";

/** Status chip row */
const ChipRow = ({ items }) => (
  <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "14px" }}>
    {items.map((s, i) => (
      <div key={i} className="sad-status-chip" style={{ border: `1px solid ${s.color}22` }}>
        <span style={{ color: T.muted }}>{s.label}</span>
        <span style={{ fontWeight: 700, color: s.color }}>{s.value}</span>
      </div>
    ))}
  </div>
);

export default ChipRow;
